import { IProduct, IVariant } from '../../../../types';

export default function toDataLayer(
  product: IProduct,
  variant?: IVariant,
  prefix: string = 'product_',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any[]> {
  // If no variant is explicitly provided, use the first variant from the product
  if (!variant && product.variants && product.variants.length > 0) {
    variant = product.variants[0];
  }

  if (!variant) {
    return {};
  }

  const { id, display_name, product_id, title, short_description, url } =
    product;
  const {
    media,
    perlgem,
    perlgem_sku_id,
    price,
    prices,
    size,
    shade,
    shades,
    sku,
  } = variant;
  const large_imgs_urls = media?.large || [];
  const sku_base_id = perlgem?.SKU_BASE_ID || perlgem_sku_id || '';
  const variant_price =
    prices?.length > 0
      ? prices[0].exclude_tax.price_formatted || price || 'N/A'
      : price || 'N/A';
  const variant_shade =
    shades?.length > 0 ? shades[0].title || shade || '' : shade || '';

  // Construct and return the data layer object
  return {
    [`${prefix}base_id`]: [id || product_id],
    [`${prefix}category`]: ['TBD'],
    [`${prefix}id`]: [`PROD${id || product_id}`],
    [`${prefix}name`]: [display_name || title],
    [`${prefix}price`]: [variant_price],
    [`${prefix}product_code`]: [sku],
    [`${prefix}shade`]: [variant_shade],
    [`${prefix}short_desc`]: [short_description || ''],
    [`${prefix}size`]: [size],
    [`${prefix}sku`]: [sku_base_id],
    [`${prefix}sku_large_image_url`]: [large_imgs_urls[0] || ''],
    [`${prefix}url`]: [url],
    [`${prefix}was_price`]: ['TBD'],
  };
}

export function formatProductData(productData: IProduct) {
  if (!productData.product_base_id) return;

  const formattedProductData = { ...productData };

  formattedProductData.product_price = [
    Number.parseFloat(formattedProductData.product_price?.[0] || '0').toFixed(
      2,
    ),
  ];
  formattedProductData.product_sku = [
    `SKU${String(formattedProductData.product_sku?.[0] || '')}`,
  ];
  formattedProductData.product_category = [''];
  formattedProductData.product_impression_list = [location.pathname];
  formattedProductData.product_is_replenishment_item = ['no'];
  formattedProductData.product_replenishment_frequency = [''];

  return formattedProductData;
}
